module.exports = __webpack_public_path__ + "static/media/undraw_cancel_re_pkdm.f3d3378e.svg";